import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PtsPaymentTerminal } from 'src/app/features/payment-terminal/pts/pts-payment-terminal-model';

@Injectable({
  providedIn: 'root',
})
export class PaymentTerminalSharedService {
  private refreshOverviewEmitter = new Subject<PtsPaymentTerminal>();

  emitRefreshEvent(data: PtsPaymentTerminal) {
    this.refreshOverviewEmitter.next(data);
  }

  getRefreshEventEmitter() {
    return this.refreshOverviewEmitter.asObservable();
  }
}
